export class LoggingError extends Error {
    constructor(code, message) {
        super(message);
        // Object for storing properties of an event that's useful for debugging.
        this.debug = {};
        this.name = 'LoggingError';
        this.message = message;
        this.code = code;
    }
}
//# sourceMappingURL=logging.js.map